import React, { useEffect, useState } from 'react';
import { OnboardingActions } from '@portal/actions';
import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';
import AdvancedForm from '@portal/components/AdvancedForm/AdvancedForm';
import ConfirmationModal from '@portal/components/ConfirmationModal/ConfirmationModal';
import PanelContentHeader from '@portal/components/PanelContentHeader/PanelContentHeader';
import useReduxState from '@portal/hooks/useReduxState';
import { maskPhoneInput, unmaskField } from '@portal/services/masks';
import { Input } from 'antd';
import { useDispatch } from 'react-redux';
import * as MessageService from '~/services/message';
import * as StorageService from '~/services/storage';
import { generateKeyPair } from '@portal/repositories/securitySdkConfig';
import { translate } from '@portal/services/i18n';
import { ONBOARDING_CELLPHONE_STATUS } from '@portal/actions/actionTypes';
import { validateStatus } from '@portal/enum/validateStatus';
import { useNavigation } from '@portal/hooks/useNavigation';
import { TokenMethod } from '@portal/enum/device';

const RegisterNumber = () => {
  const dispatch = useDispatch();
  const navigate = useNavigation();
  const {
    onboarding: { cellPhoneStatus, registerDevice, validateToken },
  } = useReduxState();

  const [openModal, setOpenModal] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');

  const handleConfirmation = () => {
    dispatch(OnboardingActions.validateCellphone(unmaskField(phoneNumber)));
  };

  const handleRegisterDevice = () => {
    const deviceId = StorageService.getOrCreateDeviceId();
    StorageService.setItem('device-id', deviceId);

    const { publicKey, privateKey } = generateKeyPair();

    if (StorageService.getItem('register-private-key')) {
      StorageService.removeItem('register-private-key');
    }

    StorageService.setItem('register-private-key', privateKey);

    const requestData: models.OnboardingRegisterDeviceRequest = {
      deviceInfo: {
        deviceId,
        cellphone: `55${phoneNumber}`,
        deviceType: 3,
        model: '',
        manufacturer: '',
        carrier: '',
      },
      publicKey,
      sendEmail: false,
      method: TokenMethod.SMS,
    };
    dispatch(OnboardingActions.onboardingRegisterDevice(requestData));
    dispatch({ type: ONBOARDING_CELLPHONE_STATUS, payload: null });
  };

  const handleSubmit = () => {
    handleConfirmation();
  };

  useEffect(() => {
    if (validateToken) {
      navigate('/abertura-de-conta');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateToken]);

  const handleValidateToken = (code: string) => {
    dispatch(
      OnboardingActions.onboardingValidateDevice({
        code,
        cellphone: `55${phoneNumber}`,
      })
    );
  };

  useEffect(() => {
    if (cellPhoneStatus) {
      if (cellPhoneStatus === validateStatus.OK) {
        handleRegisterDevice();
      } else if (cellPhoneStatus === validateStatus.IN_USE) {
        MessageService.error('PAGES.AUTH.REGISTER_NUMBER.ERRORS.IN_USE', {
          domain: 'validation',
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cellPhoneStatus]);

  useEffect(() => {
    if (registerDevice) {
      setOpenModal(true);
    }
  }, [registerDevice]);

  return (
    <>
      <div className="register-number">
        <PanelContentHeader
          pageTitle={translate('PAGES.AUTH.REGISTER_NUMBER.MODAL_CONFIRM')}
        />
        <AdvancedForm onSubmit={handleSubmit}>
          <p className="register-number__text">
            {translate('PAGES.AUTH.REGISTER_NUMBER.TITLE')}
          </p>
          <Input
            placeholder="(99) 99999-9999"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(maskPhoneInput(e.target.value))}
          />
          <AdvancedButton text="Continuar" type="submit" />
        </AdvancedForm>
      </div>

      {/* TODO: Colocar input aqui */}
      {/* NÃO DEVE SER ESSE COMPONETNE */}
      <ConfirmationModal
        visible={openModal}
        setVisible={setOpenModal}
        handleConfirmation={handleValidateToken}
        title={translate('PAGES.AUTH.REGISTER_NUMBER.MODAL_CONFIRM')}
        text={`${translate(
          'PAGES.AUTH.REGISTER_NUMBER.DESCRIPTION'
        )} ${phoneNumber}. ${translate(
          'PAGES.AUTH.REGISTER_NUMBER.DESCRIPTION_COMPLETE'
        )}`}
        isSms
      />
    </>
  );
};

export default RegisterNumber;
